import * as yup from 'yup';

const FeedbackAppointmentSchema = yup.object({
  // rating: yup.number().required('Rating is required'),
  // notes: yup.string().required('Notes is required'),
  issues: yup.array().required('Issues is required'),
});

export { FeedbackAppointmentSchema };
